<template>
    <div class="ticket-page">

        <!-- 顶部统计Tab -->
        <div class="ticket-tab-wrap">
            <div v-for="(item, index) in tabList" :key="index" @click="switchTab(item.status)" class="tab-item"
                :class="{ active: activeTab === item.status }">
                <div class="tab-title">{{ item.label }}</div>
                <div class="tab-count">{{ item.count }}</div>
            </div>
        </div>

        <!-- 筛选查询区域 -->
        <el-form :model="searchParams" inline label-width="80px">
            <!-- <el-form-item label="创建时间">
                <el-date-picker size="small" v-model="searchParams.timeRange" type="daterange" range-separator="-"
                    start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button size="small" @click="quickDate(1)">1天</el-button>
                <el-button size="small" @click="quickDate(3)">3天</el-button>
                <el-button size="small" @click="quickDate(7)">7天</el-button>
            </el-form-item> -->
            <el-form-item label="创建时间">
                <el-date-picker size="small" v-model="searchParams.timeRange" type="datetimerange"
                    :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" align="center">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="工单编号">
                <el-input size="small" v-model="searchParams.ticket_sn" placeholder="请输入工单编号"></el-input>
            </el-form-item>
            <el-form-item label="工单标题">
                <el-input size="small" v-model="searchParams.title" placeholder="请输入工单标题"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" @click="getDataList">查询</el-button>
                <el-button size="small" @click="resetSearch">重置</el-button>
            </el-form-item>
        </el-form>
        <div style="margin-bottom: 15px;">
            <el-button size="small" type="primary" @click="openCreate">创建工单</el-button>
        </div>
        <!-- 工单表格 -->
        <el-table v-loading="loading" :data="tableData"
            :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
            <el-table-column label="工单编号" prop="ticket_sn" />
            <el-table-column label="工单标题" prop="title" width="220" />
            <!-- 工单类型：Tag标签展示 -->
            <el-table-column label="类型" prop="ticket_type_name">
                <template slot-scope="scope">
                    <el-tag type="success" size="small">{{ scope.row.ticket_type_name }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="状态" prop="status_name">
                <template slot-scope="scope">
                    <span :class="statusClass(scope.row.status)">● {{ tabList_status[scope.row.status] }}</span>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="created_at" />
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="openDetail(scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit"
            @pagination="getDataList" layout="total, sizes, prev, pager, next, jumper" v-if="page_data.total > 0" />
        <!-- 工单详情抽屉子组件 -->
        <TicketDetailDrawer :visible.sync="drawerVisible" :ticket-id="drawer_id" @refresh-table="getDataList" />
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Pagination from "@/components/pagination/pagination.vue";
import TicketDetailDrawer from './ticketDetailDrawer.vue'
export default {
    components: {
        Pagination,
        TicketDetailDrawer,
    },
    data() {
        return {
            // 顶部统计tab
            tabList: [
                { label: '全部工单', status: '0', count: 0 },
                { label: '待处理', status: '1', count: 0 },
                { label: '处理中', status: '2', count: 0 },
                { label: '待确认', status: '3', count: 0 },
                // { label: '待评价', status: '4', count: 0 },
                // { label: '已评价', status: '5', count: 0 }
            ],
            tabList_status: {
                1: '待处理',
                2: '处理中',
                3: '待确认',
                4: '已完成'
            },
            activeTab: '0',
            // 搜索参数
            searchParams: {
                status: '',
                timeRange: [],
                ticket_sn: '',
                title: ''
            },

            // 表格分页
            tableData: [],
            loading: false,
            page_data: {
                limit: 10,
                page: 1,
                total: 0,
            },
            // 新增弹窗
            createVisible: false,
            form: {
                ticket_type: '',
                title: '',
                content: '',
                files: []
            },
            rules: {
                ticket_type: [{ required: true, message: '请选择工单类型', trigger: 'change' }],
                title: [
                    { required: true, message: '请输入工单标题', trigger: 'blur' },
                    { min: 3, max: 50, message: '标题长度3-50字符', trigger: 'blur' }
                ],
                content: [
                    { required: true, message: '请描述你的问题', trigger: 'blur' },
                    { min: 10, message: '描述至少10个字', trigger: 'blur' }
                ]
            },
            pickerOptions: {
                shortcuts: [{
                    text: '当天',
                    onClick(picker) {
                        const end = new Date()
                        const start = new Date()
                        // 重置为当日0点
                        start.setHours(0, 0, 0, 0)
                        picker.$emit('pick', [start, end])
                    }
                },
                {
                    text: '昨天',
                    onClick(picker) {
                        const end = new Date()
                        const start = new Date()
                        // 先减1天，再置为昨天0点
                        start.setDate(start.getDate() - 1)
                        start.setHours(0, 0, 0, 0)
                        // 结束时间为今天0点
                        end.setHours(0, 0, 0, 0)
                        picker.$emit('pick', [start, end])
                    }
                },
                {
                    text: '最近3天',
                    onClick(picker) {
                        const end = new Date()
                        const start = new Date()
                        start.setDate(start.getDate() - 2)
                        start.setHours(0, 0, 0, 0)
                        picker.$emit('pick', [start, end])
                    }
                },
                {
                    text: '最近7天',
                    onClick(picker) {
                        const end = new Date()
                        const start = new Date()
                        start.setDate(start.getDate() - 6)
                        start.setHours(0, 0, 0, 0)
                        picker.$emit('pick', [start, end])
                    }
                }]
            },
            drawerVisible: false,
            drawer_id: 0,
        }
    },
    mounted() {

    },
    methods: {
        ...mapActions({
            opGetUserTicket: 'ucenter/opGetUserTicket',
        }),
        initData() {
            this.getTicketTabCount()
            this.getDataList()
        },
        // 切换顶部状态Tab
        switchTab(status) {
            this.activeTab = status
            this.searchParams.status = status
            this.page = 1
            this.getDataList()
        },

        // 获取顶部各状态统计数量
        getTicketTabCount() {
            //   const res = await this.$axios.get('/merchant/ticket/count')
            //   if (res.code === 200) {
            //     this.tabList[0].count = res.data.all
            //     this.tabList[1].count = res.data.processing
            //     this.tabList[2].count = res.data.wait_confirm
            //     this.tabList[3].count = res.data.wait_comment
            //   }
        },

        // 快捷时间筛选 1/3/7天
        quickDate(day) {
            const end = new Date()
            const start = new Date()
            start.setDate(start.getDate() - day)
            this.searchParams.timeRange = [start, end]
            this.page = 1
            this.getDataList()
        },

        // 重置搜索条件
        resetSearch() {
            this.searchParams = {
                status: 0,
                timeRange: [],
                ticket_sn: '',
                title: ''
            }
            this.page = 1
            // this.getDataList()
            this.switchTab('0')
        },

        // 获取工单列表
        getDataList() {
            this.tableData = []
            this.loading = true
            let param = { page_size: this.page_data.limit, page: this.page_data.page, ...this.searchParams }
            this.opGetUserTicket({
                data: param,
                success: (res) => {
                    this.loading = false
                    if (res.code == 200) {
                        this.tableData = res.data.list
                        const ticketTabCount = res.data.ticketTabCount || []
                        if (ticketTabCount) {
                            this.tabList.forEach(item => {
                                item.count = ticketTabCount[item.status] ?? 0;
                            });
                        }
                        this.page_data.total = res.data.total
                    } else {
                        this.$message.error(res.message)
                    }

                }
            })
        },
        // 状态文字颜色
        statusClass(status) {
            const map = {
                1: 'text-orange',
                2: 'text-blue',
                3: 'text-green',
                4: 'text-yellow'
            }
            return map[status] || ''
        },
        // 打开新增弹窗
        openCreate() {
            this.$emit('check_add', 1)
        },

        // 关闭弹窗重置表单
        resetForm() {
            this.$refs.form?.resetFields()
            this.form.files = []
        },
        // 查看详情（可自行扩展详情弹窗）
        openDetail(row) {
            this.drawer_id = row.id
            this.drawerVisible = true
        }
    }
}
</script>

<style scoped>
.text-orange {
    color: #e6a23c;
}

.text-blue {
    color: #409eff;
}

.text-green {
    color: #07e8f0;
}

.text-yellow {
    color: #67c23a;

}

.ticket-tab-wrap {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
    position: relative;
}

/* 整条通栏底部连接线，紧贴所有tab底部，完全重合 */
.ticket-tab-wrap::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 2px;
    background-color: #eee;
    z-index: 1;
}

.tab-item {
    flex: 1;
    padding: 10px 0;
    text-align: center;
    border-top: 1px solid #e4e7ed;
    border-left: 1px solid #e4e7ed;
    border-right: 1px solid #e4e7ed;
    border-radius: 6px 6px 0 0;
    cursor: pointer;
    position: relative;
    /* 让卡片底边盖住通栏线，视觉贴合无空隙 */
    /* z-index: 2;
    transition: all 0.2s; */
}

/* 四个tab不同浅色背景 */
.tab-item:nth-child(1) {
    background: -moz-linear-gradient(top, rgba(25, 102, 255, .05) 0, rgba(25, 102, 255, 0) 100%);
    background: linear-gradient(180deg, rgb(132 153 195 / 5%), rgba(25, 102, 255, 0))
}

/* 全部工单 */
.tab-item:nth-child(2) {
    background: -moz-linear-gradient(top, rgba(25, 102, 255, .05) 0, rgba(25, 102, 255, 0) 100%);
    background: linear-gradient(180deg, rgba(25, 102, 255, .05), rgba(25, 102, 255, 0))
}

/* 处理中 */
.tab-item:nth-child(3) {
    background: -moz-linear-gradient(top, rgba(255, 146, 38, .05) 0, rgba(255, 146, 38, 0) 100%);
    background: linear-gradient(180deg, rgba(255, 146, 38, .05), rgba(255, 146, 38, 0))
}

/* 待确认 */
.tab-item:nth-child(4) {
    background: -moz-linear-gradient(top, rgba(67, 191, 10, .05) 0, rgba(67, 191, 10, 0) 100%);
    background: linear-gradient(180deg, rgba(67, 191, 10, .05), rgba(67, 191, 10, 0))
}

/* 待评价 */

/* 激活态样式 */
.tab-item.active {
    background-color: #ffffff !important;
    border-top: 3px solid #409eff;
}

/* hover悬浮变纯白 */
.tab-item:hover {
    background: #ffffff !important;
}

.tab-title {
    font-size: 16px;
    color: #666;
}

.tab-count {
    font-size: 26px;
    font-weight: bold;
    margin-top: 8px;
}
</style>